<script lang="ts">
  import { createEventDispatcher, onMount, onDestroy } from 'svelte';
  import { _ } from 'svelte-i18n';

  // Props
  export let show: boolean = true;
  export let showButton: boolean = true;

  const dispatch = createEventDispatcher();

  // Hide banner after March 31, 2026
  const EXPIRY_DATE = new Date('2026-03-31T23:59:59');
  const isExpired = new Date() > EXPIRY_DATE;

  // Delay showing the banner by 2 seconds
  let delayElapsed = false;
  let timeoutId: ReturnType<typeof setTimeout>;

  onMount(() => {
    timeoutId = setTimeout(() => {
      delayElapsed = true;
    }, 2000);
  });

  onDestroy(() => {
    if (timeoutId) clearTimeout(timeoutId);
  });

  function handleGoToSettings() {
    dispatch('goToSettings');
  }

  $: shouldShow = show && delayElapsed && !isExpired;
</script>

{#if shouldShow}
  <div class="migration-banner">
    <div class="banner-content">
      <div class="banner-text">
        <strong>{$_('migration.banner_title')}</strong>
        <p>{$_('migration.banner_description')}</p>
      </div>
      {#if showButton}
        <div class="banner-actions">
          <button type="button" class="add-email-btn" on:click={handleGoToSettings}>
            {$_('migration.add_email')}
          </button>
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .migration-banner {
    background-color: transparent;
    border: 1px solid var(--pico-del-color);
    border-radius: var(--pico-border-radius);
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .banner-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  @media (min-width: 768px) {
    .banner-content {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }

  .banner-text {
    flex: 1;
    color: var(--pico-del-color);
  }

  .banner-text strong {
    display: block;
    margin-bottom: 0.25rem;
  }

  .banner-text p {
    margin: 0;
    font-size: 0.875rem;
    opacity: 0.85;
  }

  .banner-actions {
    display: flex;
    gap: 0.5rem;
    flex-shrink: 0;
  }

  .add-email-btn {
    margin: 0;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }
</style>
